import React, { FC, createContext, useState } from "react";
import { Route, RouteComponentProps, Switch } from "react-router";
import ProductsNavigation from "./components/ProductsNavigation";
import OrganizationProductCategoryPage from "./pages/Category";
import { OrganizationProductCompositionPage } from "./pages/Composite";
import OrganizationProductIndexPage from "./pages/Index";
import OrganizationProductPackagePage from "./pages/Package";
import OrganizationProductGroupsPage from "./pages/ProductGroup";

type ProductMenuStateType = "products" | "packages" | "composites" | "";

interface ProductsMenuContextType {
	menuState: ProductMenuStateType;
	setMenuState: (menuState: ProductMenuStateType) => void;
}
export const ProductsMenuContext = createContext<ProductsMenuContextType>({
	menuState: "",
	setMenuState: (menuState: ProductMenuStateType) => {},
});

const OrganizationProductPage: FC<RouteComponentProps> = (props) => {
	const [menuState, setMenuState] = useState<ProductMenuStateType>("products");

	return (
		<ProductsMenuContext.Provider
			value={{
				menuState,
				setMenuState,
			}}
		>
			<div className="page-container">
				<ProductsNavigation />
				<div className="content">
					<Switch>
						<Route path={`${props.match.url}/categories`} component={OrganizationProductCategoryPage} />
						<Route path={`${props.match.url}/packages`} component={OrganizationProductPackagePage} />
						<Route path={`${props.match.url}/composite`} component={OrganizationProductCompositionPage} />
						<Route path={`${props.match.url}/product_groups`} component={OrganizationProductGroupsPage} />
						<Route path={props.match.url} component={OrganizationProductIndexPage} />
					</Switch>
				</div>
			</div>
		</ProductsMenuContext.Provider>
	);
};
export default OrganizationProductPage;
